/** Formatting used inside generated flag text (UI has its own formatters). */

export type MoneyFormatter = (n: number) => string;

/** Currency-aware money formatter; defaults to USD when the file gave no signal. */
export function makeMoneyFormatter(currency: string | null): MoneyFormatter {
  const fmt = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currency ?? 'USD',
  });
  return (n) => fmt.format(n);
}

export function fmtDate(d: Date): string {
  return d.toLocaleDateString('en', { month: 'short', day: 'numeric', year: 'numeric' });
}
